export default `
window.API_STQR = (function(qr){
    const env = window["STQR_API_ENV"] || {};
    const BE = env.serverRoot;

    const getPath = ()=>{
        const urlEnd = qr.experiences[0].assets[0].data;
        var fullPath = "";
        if (urlEnd.startsWith("media/")) {
            fullPath = env.bearMedia + urlEnd;
        } else {
            fullPath = env.mediaRoot + "videos/" + urlEnd;
        }
        return fullPath;
    };

    const tusLoaded = new Promise((a,r)=>{
        var script = document.createElement("script");
        script.src = "./assets/tusMin.js";
        script.onload = a;
        script.onerror = r;
        document.head.appendChild(script);
    })

    async function addConsents( qrcodeId,
        termsAndConditionsConsent,
        shareEmailConsent
    ) {
        const formData = new FormData();
        if(termsAndConditionsConsent){formData.append("termsAndConditionsConsent", termsAndConditionsConsent);}
        if(shareEmailConsent){formData.append("shareEmailConsent", shareEmailConsent);}
        const response = await fetch(BE+"consents/"+qrcodeId, {
            method: 'POST',
            headers: {
                //"Content-Type": "multipart/form-data"
            },
            body: formData
        });
        const responseData = await response.json();
        return responseData;
    }

    async function videoPartialUpload(file, onProgressCb) {
        return new Promise((resolve, reject) => {
            const upload = new tus.Upload(file, {
                endpoint: BE+"uploads",
                retryDelays: [0, 3000, 5000, 10000, 20000],
                chunkSize: 5 * 1024 * 1024,
                metadata: {
                    filename: file.name,
                    filetype: file.type
                },
                onError: (error) => {
                    console.error("Video upload failed because: " + error);
                    reject(error);
                },
                onProgress: (bytesUploaded, bytesTotal) => {
                    onProgressCb(Number(((bytesUploaded / bytesTotal) * 100).toFixed(2)));
                },
                onSuccess: () => {
                    if (upload.url) {
                        resolve(upload.url);
                    }
                }
            });
    
            // Check if there are any previous uploads to continue.
            upload.findPreviousUploads().then(previousUploads => {
                // Found previous uploads so we select the first one.
                if (previousUploads.length) {
                    upload.resumeFromPreviousUpload(previousUploads[0]);
                }
    
                upload.start();
            });
        });
    }

    return {
        version: "1.0",
        //qrcode : qr,
        hasVideo(){
            return qr.status === "USED";
        },
        resetVideo(){
            try{
                const formData = new FormData();
    
                const response = fetch(BE+"experiences/reset/"+qr.QRid, {
                    method: 'POST',
                    headers: {
                        //"Content-Type": "multipart/form-data"
                    },
                    body: formData
                });
                
                return response.then(r=>{
                    qr.status = "BLANK";
                    return true;
                });
            }catch(e){
                console.error(e);
                return Promise.resolve(false);
            }
        },
        sendVideo(videoFile, onProgress, userData ){
            return tusLoaded.then(async ()=>{
                try {
                    await addConsents(qr.QRid, true);
                    const videoUrl = await videoPartialUpload(videoFile, onProgress);
        
                    const formData = new FormData();
                    formData.append("video", videoUrl);
                    formData.append("name", videoFile.name || "name");
        
                    Object.keys(userData).forEach(key => {
                        if (userData[key] && userData[key].toString().length > 0) {
                            formData.append(key, userData[key]);
                        }
                    });
        
                    const response = await fetch(BE+"experiences/video/"+qr.QRid, {
                        method: 'POST',
                        headers: {
                            //"Content-Type": "multipart/form-data"
                        },
                        body: formData
                    });
                    
                    const responseData = await response.json();
                    if(!qr.experiences){qr.experiences=[];}
                    qr.experiences[0] = responseData;
                    qr.status = "USED";
                    return getPath();
                } catch (e) {
                    console.error(e);
                }
            });
        },
        getVideoPath(){
            return getPath(); //qr.videoPath;
        },
        isReported(){
            return qr.projectReported;
        },
        isBanned(){
            return qr.projectBanned;
        },
        reportVideo(reason, params){
            if(!params){params = {};}
            const ar = [
                "HATE",
                "NUDITY_SEX",
                "ANIMAL_CRUELTY",
                "SUICIDE_SELF_INJURY",
                "BULLYING",
                "FAKE_NEWS",
                "VIOLENCE",
                "SCAM",
                "SALE_ILLEGAL",
                "INTELLECTUAL_VIOLATION",
                "CHILDREN_SAFETY"
            ];
            if(ar.indexOf(reason)<0){
                console.warn("Reason of report must me one of the among:", ar);
                return;
            }
            const formData = new FormData();
            formData.append("reason", reason);
            formData.append("videoUrl", getPath());
            ["reporterEmail", "reporterFirstName", "reporterLastName", "reporterMessage"].forEach(p=>{
                if(params[p]){
                    formData.append(p, params[p]);
                }
            });

            const response = fetch(BE+"report/"+qr.QRid, {
                method: 'POST',
                headers: {
                },
                body: formData
            });
            
            return response.then(r=>r.json());
        },
    };
})`;